module.exports = __webpack_public_path__ + "media/images/icons/ingredient-icon-ecc9bfee04ccfe444eae36e8a7742dbd.svg";